define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/modules",
	"csi/comm",
	"csi/def",
	"csi/def/Field",
	"csi/form/Widget",
	"csi/locale",
	"csi/state/rootStore",
	"csi/xml"
], function(declare,lang,modules,comm,def,Field,Widget,locale,{ routerStore },xml) {
	const REVIEW_SUPPLIER_FACTORY = "ReviewSupplierFactory";
	const REVIEW_SUPPLIER = "ReviewSupplier";

	return declare(Widget, {
		FIELD_REQUEST: "ReviewRequest",

		/** @property {boolean} isFDDEnabled - indicate if enable the FDD on this Style */
		isFDDEnabled: null,

		/** @property {string} sourceFieldId - the field ID of the source(Supplier or SupplierFactory) */
		sourceFieldId: null,

		onChangeCreateSamples: function(/*def.View*/defView, /*Field*/field, /*Any*/value) {
			// summary: update button states based on change
			this.viewParent.set("disabled",false);
		},

		onValidateCreateSamples: function(/*def.View*/defView, /*Field*/field, /*Any*/value) {
			// summary: if state of supplier request is not draft or issued, then cannot create samples
			var	urlRequest = defView.getFieldValue(this.FIELD_REQUEST);

			if (value && xml.isValidURL(urlRequest)) {
				var	request = this.cacheView.getNode(urlRequest, true);

				if (request && (request.State != "SupplierRequestState:Draft") && (request.State != "SupplierRequestState:Issued")) {
					throw new Error(locale.resource("SizeChartReviewCreateSamplesError"));
				}
			}
		},

		/**
		 * @override
		 * initialize source field
		 */
		_buildView() {
			const cache = this.getCache();
			const { defView, FIELD_REQUEST, isFDDEnabled, sourceFieldId } = this;
			const m_id = sourceFieldId;

			const reviewRequest = this.getField(FIELD_REQUEST);
			reviewRequest.m_dependency = isFDDEnabled? REVIEW_SUPPLIER_FACTORY : REVIEW_SUPPLIER;
			const hiddenFieldId = isFDDEnabled ? REVIEW_SUPPLIER: REVIEW_SUPPLIER_FACTORY;
			defView.removeField(hiddenFieldId);

			let sourceField = this.getField(sourceFieldId);

			if (!sourceField) {
				sourceField = this.insertField(lang.mixin(new Field(), {
					m_id
				}), 3);
			}
			sourceField.m_bRequired = true;

			// initialize default value for source(ReviewSupplier or ReviewSupplierFactory)
			let node = cache.getNode(this._getSourcingUrl());
			const sizeChartNode = routerStore.getBreadcrumbNode("SizeChart");

			if (node && (node = cache.getNode(node.ProductionQuote) || cache.getNode(node.SampleQuote))) {
				node = cache.getNode(node.__Parent__);
				const sourceUrl = isFDDEnabled ? node.SupplierFactory : node.Supplier;

				this.addDefaultValue(sourceField.m_id, sourceUrl);
			} else if (sizeChartNode && xml.isValidURL(sizeChartNode.ForProductSource)) {
				const forProductSourceUrl = sizeChartNode.ForProductSource; 
				const productSource = this.cacheView.getNode(forProductSourceUrl);
				const sourceUrl = isFDDEnabled ? productSource.SupplierFactory : productSource.Supplier;

				this.addDefaultValue(sourceField.m_id, sourceUrl);
				sourceField.m_right = xml.RIGHT_NONE;
			}

			this.inherited(arguments);
		},

		/**
		 * @override
		 * query for default supplier if sourcing module is present
		 */
		_getRootRequest(node) {
			const urls = [];
			const paths = [];

			const sizeChartNode = routerStore.getBreadcrumbNode("SizeChart");

			if (sizeChartNode && xml.isValidURL(sizeChartNode.ForProductSource)) {
				urls.push(sizeChartNode.ForProductSource);
				paths.push("");
			}

			if (modules.hasModule("Sourcing")) {
				urls.push(this._getSourcingUrl());
				paths.push("Child:SampleQuote;ProductionQuote/Child:__Parent__/Child:Supplier");

				return comm.getNodeRequest(urls, null, true)
					.addDependencyPaths(paths);
			}

			return comm.getNodeRequest(urls, null);
		},

		_getSourcingUrl: function() {
			// summary: return StyleSourcing url for parent style
			const productNode = routerStore.getBreadcrumbNode("Style") || routerStore.getBreadcrumbNode("Shape");
			return productNode.ProductSourcing;
		},

		_resolveView: function() {
			// summary: add field to allow creation of samples rather than selecting existing samples
			if (modules.hasModule("Sourcing")) {
				this.insertField(lang.mixin(new Field(), {
					m_label: "SizeChartReviewCreateSamples",
					m_onChange: "onChangeCreateSamples",
					m_onValidate: "onValidateCreateSamples",
					m_typeControl: def.FIELD_CHECKBOX
				}));
			} else {
				this.defView.removeField(this.FIELD_REQUEST);
			}

			// register function to compute default review name
			this.addValueExpression(xml.ATTR_NAME, lang.hitch(this, this._valueReviewName));

			this.inherited(arguments);
		},

		_valueReviewName: function() {
			// summary: update name with subtype if not already set
			var	s1 = locale.type("SizeChartReview");
			var	s2 = locale.getEnumName(this.defView.getFieldValue("SubType"));
			if (s2) {
				s1 += " - " + s2;
			}

			return s1;
		}
	});
});